import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: 'root'
})
export class GuardianService {
  baseUrl = environment.baseUrl;
  constructor(private httpClient: HttpClient) { }

  getLast(): Observable<any> {
    const _baseUrl = this.baseUrl;
    const _route = 'farmer/last';
    const _url = _baseUrl + _route;
    return this.httpClient.get<any>(`${_url}`);
  }

  getSearch(farmer_name: string | null): Observable<any> {
    const _baseUrl = this.baseUrl;
    const _route = 'farmer/filter';
    const _farmer_name = farmer_name ? '?farmer_name=' + farmer_name : '';
    const _url = _baseUrl + _route + _farmer_name;
    return this.httpClient.get<any>(`${_url}`);
  }

  // getFarmerNames(
  //   _var: {
  //     page: number | null;
  //     page_size: number | null;
  //     farmer_name: string | null;
  //   }
  // ): Observable<any> {
  //   const _baseUrl = this.baseUrl;
  //   const _route = 'farmer/farmer-names';
  //   const _page = "?page=" + (_var.page ? _var.page + 1 : 1);
  //   const _page_size = "&page_size=" + (_var.page_size ? _var.page_size : 100);
  //   const _farmer_name = _var.farmer_name ? '&farmer_name=' + _var.farmer_name : '';
  //   const _url = _baseUrl + _route + _page + _page_size + _farmer_name;
  //   return this.httpClient.get<any>(`${_url}`);
  // }
}
